import { css } from '@emotion/react';
import { ITableProps } from 'common-components';
import { ProjectAchievementType } from '@types';
import { Loader } from '@components/utils';

import ContributionsTable from './ContributionsTable';
import Header from './Header';

type ContributionsPropsType = {
  projectsAchievement: ProjectAchievementType[]
  tableProps?: Partial<ITableProps<ProjectAchievementType>>
  isLoading?: boolean
};
const Contributions = ({
  projectsAchievement,
  isLoading,
  tableProps = {},
}: ContributionsPropsType) => {
  return (
    <>
      <Header data={{}} />
      <div
        css={css`
          margin-top: 16px;
        `}
      >
        {isLoading && <Loader />}
        {!isLoading && (
          <ContributionsTable projectsAchievement={projectsAchievement} {...tableProps} />
        )}
      </div>
    </>
  );
};

export default Contributions;
